import React, { useState, useEffect } from "react";
import Footer from "./layout/Footer";
import ReviewItem from "../components/ReviewItem";
import SignUpBtn from "../components/layout/header/SignUpBtn";
import EmailForm from "../components/EmailForm";
import AboutBenkyoSection from "./layout/AboutBenkyoSection";
import AboutBenSenseiSection from "./layout/AboutBenSenseiSection";
import AboutFaqSection from "./layout/AboutFaqSection";
import { getHomePage } from "../sanityClient";

// import assets
import BenHighSrc from "../assets/images/Ben-high.webp";

// import style
import "../style/pages/home.scss";

const componentMap = {
  aboutBenkyoSection: AboutBenkyoSection,
  aboutBenSenseiSection: AboutBenSenseiSection,
  aboutFaqSection: AboutFaqSection,
};

const renderSection = (section, index) => {
  const SectionComponent = componentMap[section._type];
  if (!SectionComponent) {
    console.warn(`Unknown section type: ${section._type}`);
    return null;
  }

  switch (section._type) {
    case 'aboutBenkyoSection':
      return (
        <SectionComponent
          key={section._key || index}
          id={section.id}
          title={section.title}
          titleSpan={section.titleSpan}
          subtitle={section.subtitle}
          content={section.content}
        />
      );
    case 'aboutBenSenseiSection':
    case 'aboutFaqSection':
      return (
        <SectionComponent
          key={section._key || index}
          id={section.id}
          title={section.title}
          titleSpan={section.titleSpan}
          subtitle={section.subtitle}
          titleType={section.titleType}
          content={section.content}
        />
      );
    default:
      return null;
  }
};

const Home = () => {
  const [pageSections, setPageSections] = useState([]);

  useEffect(() => {
    const fetchPageData = async () => {
      try {
        const data = await getHomePage();
        if (data?.pageSections) {
          setPageSections(data.pageSections);
        }
      } catch (error) {
        console.error("Error fetching home page data:", error);
      }
    };
    fetchPageData();
  }, []);

  return (
    <div className="home-section">
      <div className="container main-section">
        <div className="responsive-main-section">
          <div className="logo-top-title font-funneldisplay-bold">
            日本語に精通するベン先生の
          </div>
          <div className="logo-section">
            <div className="logo-img">
              <img src={BenHighSrc} alt="high" />
            </div>
          </div>
          <div className="logo-bottom-title font-funneldisplay-bold">
            <div className="logo-bottom-section font-funneldisplay-bold">
              英語
              <span className="bottom-text font-funneldisplay-bold">BEN</span>
              <span className="bottom-text-o font-funneldisplay-bold">KYO</span>
              会
            </div>
            <p className="logo-footer-text font-funneldisplay">
              ベン先生がいなくては、不ベンです！
            </p>
          </div>
          <div className="content-section">
            <div className="content-item font-notosans-extra-bold">
              <p className="content-item-text font-notosans-extra-bold">
                ユーモアたっぷりの、
                <br />
                本物の言語学者による
                <br />
                オンライン英語レッスン
              </p>
            </div>
            <div className="content-item font-notosans-extra-bold">
              <p className="content-item-text font-notosans-extra-bold">
                英文法から発音、ネイティブ同士の会話
                <br />
                分析まで。全コース14週間・全28時間、
                <br />
                1回2時間のレッスンが1回$35で受けられます
              </p>
            </div>
          </div>
          <div className="responsive-content-section">
            <p className="content-item-text font-notosans-extra-bold">
              ユーモアたっぷりの、本物の言語学者による オンライン英語レッスン
            </p>
            <p className="content-item-text font-notosans-extra-bold">
              英文法から発音、ネイティブ同士の会話 分析まで。
              全コース14週間・全28時間、 1回2時間の
              レッスンが1回$35で受けられます
            </p>
          </div>
          <div className="review-section">
            <ReviewItem
              classname={"r-one"}
              component={
                <>
                  “...疑問が残ることが
                  <br />
                  ほとんどないです”
                </>
              }
            />
            <ReviewItem
              classname={"r-two"}
              component={
                <>
                  “想像もしなかったような英語と日本語の違いを知ることができました”
                </>
              }
            />
            <ReviewItem
              classname={"r-three"}
              component={
                <>
                  “今までずっと不思議に思って
                  <br />
                  いたことが 解決していきます”
                </>
              }
            />
            <ReviewItem
              classname={"r-four"}
              component={
                <>
                  “ベン
                  <br />
                  かわいい”
                </>
              }
            />
          </div>
          <div className="btn-view">
            <SignUpBtn />
          </div>
        </div>
      </div>
      <div className="main-hero-section-email-form-wrapper w-full">
        <EmailForm noPaddingTop />
      </div>
      <Footer />

      {pageSections.map((section, index) => renderSection(section, index))}
    </div>
  );
};

export default Home;
